export default "{\n    \"noOptions\": \"No addresses found\"\n}\n"